import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MatButtonModule, MatFormFieldModule, MatIconModule, MatMenuModule, MatSelectModule, MatTabsModule, MatDatepickerModule, MatTooltipModule } from '@angular/material';
import { AgmCoreModule } from '@agm/core';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseWidgetModule } from '@fuse/components/widget/widget.module';
import { AuthGuardService } from '../../authentication/auth-guard.service';
import { TableModule } from 'primeng/table';
import { MultiSelectModule } from 'primeng/multiselect';
import { MatInputModule } from '@angular/material';
import { TimesheetRankComponent } from './timesheet-rank.component';

const routes = [
    { path: '', redirectTo: 'timesheet-dashboard', pathMatch: 'full', canActivate: [AuthGuardService] },
    { path: 'timesheet-dashboard', component: TimesheetRankComponent, canActivate: [AuthGuardService] },
];


@NgModule({
    declarations: [
        TimesheetRankComponent
    ],
    imports: [
        RouterModule.forChild(routes),
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatMenuModule,
        MatSelectModule,
        MatTabsModule,
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyD81ecsCj4yYpcXSLFcYU97PvRsE_X8Bx8'
        }),
        NgxChartsModule,
        FuseSharedModule,
        FuseWidgetModule,
        TableModule,
        MultiSelectModule,
        MatDatepickerModule,
        MatInputModule,
        MatTooltipModule
    ],
    providers: [
        
    ]
})
export class TimesheetRankDashboardModule {
}

